import styled, { css } from 'styled-components';
import { white, gray, symbol, secondary } from '~/components/mixins/color';
import arrow from '~/assets/arrow.svg';

export const Row = styled.div`
  display: grid; 
  grid-gap: 10px;
  grid-template-columns: repeat(${(props) => props.span || 1}, 1fr);
`;

export const AccreditContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  width: 100%;
  height: 100%;

  .contents {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: calc(100% - 60px);
  }
  .form-data {
    background: ${white.hex()};
    padding: 10px;
    padding-bottom: 0px;
    margin-bottom: 10px;
  }
  .toolbar {
    display: flex;
    min-height: 56px;
    height: 56px;
    padding: 0 10px;
    margin-top: 10px;
    background: ${white.hex()};
    align-items: center;
    justify-content: flex-end;
  }
`;

export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;

  input {
    height: 32px;
    margin-bottom: 0;
  }
`;

export const FormHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  font-weight: bold;
  min-height: 44px;
  min-height: 44px;
  padding: 0 15px;
  color:  ${gray.hex()};
  background: ${white.hex()};
  border-bottom: 1px solid ${secondary.hex()};
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;

export const FormToolbar = styled.div`
  display: flex;
  min-height: 56px;
  height: 56px;
  border-top: 1px solid ${secondary.hex()};

  .buttons {
    display: flex;
    padding-right: 10px;
    flex: 1;
    align-items: center;
    justify-content: flex-end;
  }
`;

export const TableContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: calc(100vh - 278px);
  background: ${secondary.hex()};

  .list {
    display: flex;
    height: calc(100vh - 318px);
    flex-direction: column;
    flex: 1;
  }
  .form {
    display: flex;
    position: relative;
    flex: 0 0 35%;
    flex-direction: column;
    justify-content: space-between;
    background-color: ${white.hex()};
    color: ${gray.hex()};
    width: 100%;
    margin-left: 10px;
    border-radius: 3px;
    opacity: 0;
    transition: opacity 1s ease-out;

    section {
      padding: 10px;
    }
  }
  ${(props) =>
    props.showForm &&
    css`
      .form {
        opacity: 1;
      }
      @media (max-width: 1024px) {
        .list {
          display: none;
          visibility: hidden;
        }
        .form {
          flex: 1;
          margin-left: 0px;
        }
      }
      @media (min-width: 769px) and (max-width: 1024px) {
        .form {
          flex: 0 0 45%;
        }
      }
    `}
`;

export const ActionsCell = styled.div`
  display: grid; 
  grid-gap: 1px;
  grid-template-columns: repeat(3, 1fr);
  padding: 3px 0;
  button {
    margin: 0;
    &:hover {
      background: #f7f7f7;
    }
  }
`;

export const ApprovalButton = styled.button`
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  border-radius: 3px;
  font-size: 18px;
  background: transparent;
  border: none;
  color: ${(props) => props.color || symbol.hex()};

  &:hover:enabled, &:focus:enabled {
    background: ${(props) => props.active ? props.color : white.hex()};
    color: ${(props) => props.active ? white.hex() : props.color};
    opacity: 0.85;
  }
`;

export const HiddenInput = styled.input`
  width: 0;
  height: 0;
  display: none;
  visibility: 0;
  padding: 0;
  margin: 0;
`;

export const ImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 100%;
  padding: 10px;
  background: ${secondary.hex()};

  h4 {
    color: ${gray.hex()};
    font-weight: normal;
    margin-bottom: 10px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
  }
  img {
    max-width: 180px;
  }
`;

export const Select = styled.select`
  height: 26px;
  padding: 2px 9px;
  width: 100%;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  color: ${gray.hex()};
  background: ${secondary.hex()} url(${arrow});
  background-repeat: no-repeat, repeat;
  background-position: right 8px top 50%, 0 0;
  background-size: 0.65em auto, 100%;
  border: 1px solid ${secondary.hex()};
  border-radius: 3px;
`;